import { GripVertical, MousePointer2 } from "lucide-react";
import { BLOCKS, insertBlock } from "@/components/admin/posts/blocks";

const GROUPS = [
  { title: "Tekst", ids: ["paragraph", "h2", "h3", "ul", "ol", "quote", "hr"] },
  { title: "Bilete og video", ids: ["image", "video"] },
  { title: "Frå huset", ids: ["callout", "cta", "event"] },
];

/** A rotated ghost of the chip follows the pointer while dragging (Mailchimp-feel). */
const startDrag = (e, b) => {
  e.dataTransfer.setData("application/x-hk-block", b.id);
  e.dataTransfer.setData("text/plain", "");
  e.dataTransfer.effectAllowed = "copy";
  const ghost = e.currentTarget.cloneNode(true);
  ghost.className = "palette-ghost";
  ghost.style.width = `${e.currentTarget.offsetWidth}px`;
  document.body.appendChild(ghost);
  e.dataTransfer.setDragImage(ghost, 24, 24);
  requestAnimationFrame(() => setTimeout(() => ghost.remove(), 0));
};

/** Mailchimp-style palette: grab a block and drop it where it belongs in the article – or click to add it at the cursor. */
export const BlockPalette = ({ editor }) => (
  <section className="admin-card overflow-hidden" data-testid="block-palette">
    <header className="px-4 pt-4 sm:px-5">
      <h2 className="font-display text-[15px] font-semibold tracking-[-0.01em]">Blokker</h2>
      <p className="mt-1 text-[12.5px] leading-snug text-muted-foreground">Dra ein blokk inn i saka der du vil ha han, eller klikk for å setje han inn ved markøren. I teksten kan du òg skrive <kbd className="rounded border border-border bg-background px-1 font-mono text-[11px]">/</kbd>.</p>
    </header>
    <div className="space-y-4 p-4 sm:p-5">
      {GROUPS.map((g) => (
        <div key={g.title} data-testid={`palette-group-${g.title.split(" ")[0].toLowerCase()}`}>
          <p className="mb-2 text-[10.5px] font-semibold uppercase tracking-[0.14em] text-muted-foreground">{g.title}</p>
          <ul className="grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-1">
            {g.ids.map((id) => BLOCKS.find((b) => b.id === id)).filter(Boolean).map((b) => (
              <li key={b.id}>
                <button type="button" draggable onDragStart={(e) => startDrag(e, b)} onClick={() => insertBlock(editor, b.id)} disabled={!editor} title={`${b.label} – ${b.hint}`} className="palette-chip" data-testid={`palette-${b.id}`}>
                  <span className="palette-icon"><b.icon className="h-4 w-4" /></span>
                  <span className="min-w-0 flex-1"><span className="block truncate text-[13px] font-medium leading-tight">{b.label}</span><span className="block truncate text-[11.5px] leading-tight text-muted-foreground">{b.hint}</span></span>
                  <GripVertical className="palette-grip h-4 w-4 shrink-0 text-muted-foreground/40 transition-colors" aria-hidden="true" />
                </button>
              </li>
            ))}
          </ul>
        </div>
      ))}
      <p className="flex items-center gap-1.5 text-[11.5px] text-muted-foreground"><MousePointer2 className="h-3 w-3" /> Når du dreg, viser ein gul strek kvar blokka hamnar.</p>
    </div>
  </section>
);
